/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {Link} from "react-router-dom";
import {UserGroupIcon} from "@heroicons/react/20/solid";
import {useTypedSelector} from "helpers/reducers";

interface BookingLoginWidgetProps {
    className?: string;
}

const BookingLoginButton = (props: BookingLoginWidgetProps) => {
    const {t} = useTranslation();
    const reservations = useTypedSelector(state => state.bookingLoginState.reservations);

    const loginPath = reservations.length === 0 ? "/booking/login" : "/booking/login/reservations";
    return (
        <Link className={clsx("text-cta-800")} to={loginPath}>
            <div
                className={
                    "BookingLoginButton bg-white rounded-full shadow-dark p-2 2xl:p-3 w-10 h-10 2xl:w-14 2xl:h-14 flex self-end items-center justify-center"
                }
            >
                <UserGroupIcon className={"w-6 h-6 outline-dark-600"} />
            </div>
        </Link>
    );
};

export default BookingLoginButton;
